module.exports = __webpack_public_path__ + "img/10_45.8e87e8c0.png";